import { LOCATION_CHANGE } from 'react-router-redux';

import { APP_VIEWER_GLOSSARY_IS_OPEN_SET } from '../actions/appViewerGlossaryIsOpenSet';

const initialState: boolean = false;

export default function appViewerGlossaryIsOpen(
  state: boolean = initialState,
  action,
) {
  switch (action.type) {
    case APP_VIEWER_GLOSSARY_IS_OPEN_SET:
      return action.payload;

    // When the router location changes, close the app viewer notification
    case LOCATION_CHANGE:
      return false;

    default:
      return state;
  }
}
